import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/common'

Vue.use(VueRouter)

// 登陆页面路由 name
const ROUTE_META_TITLE = '天津金展律师事务所'

const routes = [
  {
    path: "*",
    name: "home", // 首页
    component: () => import('@/views/Home.vue'),
    meta:{title:ROUTE_META_TITLE, keepAlive: true}
  },{
    path: '/login', // 登录
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta:{title:ROUTE_META_TITLE}
  },{
      path: '/about', // 金展简介
      name: 'about',
      component: () => import('@/views/About.vue'),
      meta:{title:ROUTE_META_TITLE}
  },{
    path: '/honors', // 金展荣誉
    name: 'honors',
    component: () => import('@/views/Honors.vue'),
    meta:{title:ROUTE_META_TITLE}
  },{
    path: '/customer', // 金展客户
    name: 'customer',
    component: () => import('@/views/Customer.vue'),
    meta:{title:ROUTE_META_TITLE}
  },{
    path: '/researchCenter', // 南大破产研究中心
    name: 'researchCenter',
    component: () => import('@/views/ResearchCenter.vue'),
    meta:{title:ROUTE_META_TITLE}
  },{
    path: '/contactUs', // 联系我们
    name: 'contactUs',
    component: () => import('@/views/ContactUs.vue'),
    meta:{title:ROUTE_META_TITLE}
  },{
    path: '/lawyerDetail/:id', // 专家律师详情
    name: 'lawyerDetail',
    component: () => import('@/views/LawyerDetail.vue'),
    meta:{title:ROUTE_META_TITLE, keepAlive: false}
  },{
    path: '/lawyer', // 专家律师
    name: 'lawyer',
    component: () => import('@/views/Lawyer.vue'),
    meta:{title:ROUTE_META_TITLE}
  },{
    path: '/freshTalent', // 招贤纳士
    name: 'freshTalent',
    component: () => import('@/views/FreshTalent.vue'),
    meta:{title:ROUTE_META_TITLE}
  },{
    path: '/bankruptcyBusiness/:id', // 破产业务
    name: 'bankruptcyBusiness',
    component: () => import('@/views/BankruptcyBusiness.vue'),
    meta:{title:ROUTE_META_TITLE}
  },{
    path: '/bankruptcyNews', // 破产资讯
    name: 'bankruptcyNews',
    component: () => import('@/views/BankruptcyNews.vue'),
    meta:{title:ROUTE_META_TITLE}
  },{
    path: '/lawsCases', // 法规案例
    name: 'lawsCases',
    component: () => import('@/views/LawsCases.vue'),
    meta:{title:ROUTE_META_TITLE}
  },{
    path: '/bankruptcyResearch', // 破产研究
    name: 'bankruptcyResearch',
    component: () => import('@/views/BankruptcyResearch.vue'),
    meta:{title:ROUTE_META_TITLE}
  },{
    path: '/bankruptcyAnnouncement', // 破产公告
    name: 'bankruptcyAnnouncement',
    component: () => import('@/views/BankruptcyAnnouncement.vue'),
    meta:{title:ROUTE_META_TITLE}
  },{
    path: '/periodicals', // 金展期刊
    name: 'periodicals',
    component: () => import('@/views/Periodicals.vue'),
    meta:{title:ROUTE_META_TITLE}
  },{
    path: '/columnInformation/:id', // 栏目信息
    name: 'columnNews',
    component: () => import('@/views/ColumnNews.vue'),
    meta:{title:ROUTE_META_TITLE}
  },{
    path: '/articleInformation/:id', // 栏目信息
    name: 'columnNew',
    component: () => import('@/views/ColumnNew.vue'),
    meta:{title:ROUTE_META_TITLE}
  },{
    path: '/detail/:id', // 文章内容
    name: 'columnContent',
    component: () => import('@/views/ColumnContent.vue'),
    meta:{
      title:ROUTE_META_TITLE
    }
  },{
    path: '/periodicalsDetail/:id', // 金展期刊内容
    name: 'periodicalsDetail',
    component: () => import('@/views/PeriodicalsDetail.vue'),
    meta:{
      title:ROUTE_META_TITLE, 
      requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
    }
  },{
    path: '/likeSearch', // 全站搜索
    name: 'likeSearch',
    component: () => import('@/views/LikeSearch.vue'),
    meta:{title:ROUTE_META_TITLE}
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 登陆页面路由 name
const LOGIN_PAGE_NAME = 'login'

// 跳转之前
router.beforeEach((to, from, next) => {
  window.scrollTo(0,0)
  if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
    const token = getToken()
    // 判断是否已登录
    if (token) {
      next()
    } else {
      next({
        name: LOGIN_PAGE_NAME
      })
    }
  } else {
    next()
  }
})

// 路由重复点击报错
const originalPush = router.push
router.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
